<template>
  <transition
    enter-active-class="cross-fade-enter-active"
    enter-from-class="cross-fade-enter-from"
    enter-to-class="cross-fade-enter-to"
    leave-active-class="cross-fade-leave-active"
    leave-from-class="cross-fade-leave-from"
    leave-to-class="cross-fade-leave-to"
  >
    <div v-show="show">
      <slot />
    </div>
  </transition>
</template>

<script setup lang="ts">
const props = defineProps({
  show: Boolean
})
</script>

<style scoped>

</style>
